import { useCallback, useEffect, useState } from 'react';
import { Flex, useBreakpointValue } from '@chakra-ui/react';

import DTTable from './DTTable';
import DataTableSearch from './DTSearch';
import DataTableCards from './DTCards';
import DataTablePaginate from './DTPaginate';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';

type TextAlertData = {
	header: string;
	body: string;
	is_toast: boolean;
}
type LancamentoData = {
	caixa: string;
	compensado: boolean;
	data: string;
	doc: string;
	fin_json: FinJsonDTO;
	id_lancamento: string;
	name_pay: string;
	nome: string;
	operacao: string;
	operacao_tipo: string;
	url_pay: string;
	vlr_cred: number;
	vlr_cred_formatted?: string;
	vlr_deb: number;
	vlr_deb_formatted?: string;
};
type UpdateListData = {
	page: number;
	perPage: number;
	lancs: LancamentoData[];
};

interface DTLancamentosParams {
	data: LancamentoData[];
	setLancamentoModal: (lancamento: FinJsonDTO) => void;
	setModalLancamentoVisible: (open: boolean) => void;
	setModalLancamentoEditVisible: (open: boolean) => void;
	setLancamentoDelete: (lanc: FinJsonDTO) => void;
	setOpenAlert: (open: boolean) => void;
	setTextAlert: (texts: TextAlertData) => void;
}

const DTLancamentos: React.FC<DTLancamentosParams> = ({ 
	data,
	setLancamentoModal,
	setModalLancamentoVisible,
	setModalLancamentoEditVisible,
	setLancamentoDelete,
	setOpenAlert,
	setTextAlert,
}) => {

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const [loading, setLoading] = useState(true);

	const [pesqLancamentos, setPesqLancamentos] = useState<LancamentoData[]>(data);
	const [lancamentos, setLancamentos] = useState<LancamentoData[]>(data.slice(0, 10));

  const [sort, setSort] = useState({ por: '', cres: true });
  const [controls, setControls] = useState({
    page: 1,
    perPage: 10,
    totalPage: Math.ceil(data.length / 10),
  });

	// const [parcsBaixa, setParcsBaixa] = useState<string[]>([]);
	// const [pagesBaixa, setPagesBaixa] = useState<number[]>([]);

  useEffect(() => {
    // setLancamentos(data.slice(0, 10));
    setLoading(false);
  }, []);

	const handleUpdateList = useCallback(({ page, perPage, lancs }: UpdateListData) => {
    const auxPage = page - 1;
    const start = auxPage * perPage;
    const end = start + perPage;

		setLancamentos(lancs.slice(start, end));
  }, []);

  return (
    <Flex w="100%" flexDir="column">
      <DataTableSearch
        lancamentos={data}
				setPesqLancamentos={setPesqLancamentos}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />

      {isWideVersion && (
				<DTTable
					lancamentos={lancamentos}
					pesqLancamentos={pesqLancamentos}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
					setLancamentoModal={setLancamentoModal}
					setModalLancamentoVisible={setModalLancamentoVisible}
					setModalLancamentoEditVisible={setModalLancamentoEditVisible}
					setLancamentoDelete={setLancamentoDelete}
					setOpenAlert={setOpenAlert}
					setTextAlert={setTextAlert}
				/>
      )}

      {!isWideVersion && !loading && (
				<DataTableCards
					lancamentos={lancamentos}
					setLancamentoModal={setLancamentoModal}
					setModalLancamentoVisible={setModalLancamentoVisible}
					setModalLancamentoEditVisible={setModalLancamentoEditVisible}
					setLancamentoDelete={setLancamentoDelete}
					setOpenAlert={setOpenAlert}
					setTextAlert={setTextAlert}
				/>
			)}

      <DataTablePaginate
				pesq_length={pesqLancamentos.length}
        pesqLancamentos={pesqLancamentos}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />
    </Flex>
  );
};

export default DTLancamentos;
